import React from 'react';

const BrowserIcon = ({ width = 24, height = 24, color = '#00a4e3' }) => {
  return (
    <svg
      width={`${width}`}
      height={`${height}`}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path
          id="Icon/browser"
          d="M3.00002 7.79844H21M4.80002 21.5984C3.47454 21.5984 2.40002 20.5239 2.40002 19.1984V4.79844C2.40002 3.47295 3.47454 2.39844 4.80002 2.39844H19.2C20.5255 2.39844 21.6 3.47295 21.6 4.79844V19.1984C21.6 20.5239 20.5255 21.5984 19.2 21.5984H4.80002Z"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      </g>
    </svg>
  );
};

export default React.memo(BrowserIcon);
